import { GithubFilled, DesktopOutlined } from "@ant-design/icons";

interface ProjectInfoProps {
    name: string;
    description?:string;
    stack: string;
    link: string;
    github: string;
}
export function ProjectInfo({ name, description, stack, link, github }: ProjectInfoProps) {
    return (
        <div className="lg:w-[350px] w-11/12 gap-y-6 flex flex-col lg:h-[350px] min-h-[300px] self-center pb-6 lg:pb-0">
            <div className="bg-white lg:h-[200px] min-h-[150px] flex flex-col justify-center p-6 rounded-md">
                <h1 className="text-lg font-bold font-dmsans">{name}</h1>
                <p className="italic font-roboto">{description}</p>
            </div>
            <div className="bg-white lg:h-[150px] h-[100px] flex flex-col justify-center p-6 space-y-4 rounded-md">
                <div className="flex flex-row space-x-6">
                    {github && <a href={github} target="_blank" rel="noopener noreferrer" className="border-none shadow-none text-gray-800 hover:text-red-600">
                        <GithubFilled style={{ fontSize: '20px' }}/>
                    </a>}
                    {link && <a href={link} target="_blank" rel="noopener noreferrer" className="border-none shadow-none text-gray-800 hover:text-red-600">
                        <DesktopOutlined style={{ fontSize: '20px' }}/>
                    </a>}
                </div>
                <p className="font-roboto font-light">Built with: <span className="italic">{stack}</span></p>            </div>
        </div>
    )
}